export default __webpack_public_path__ + "static/gitops-d65d425e65f4b702a5d63b684f37b6f9.png";